import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import {
  ApiResponse,
  SortEvent,
} from 'src/app/shareModule/models/common.model';
import { AddProductComponent } from '../../admin/sub-admin/add-product/add-product.component';
import { Member } from '../admin-members-analytics/admin-members-analytics.model';
import { NgbdSortableHeader } from 'src/app/shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import {
  PROFILE_CHARACTER_TYPE,
} from '../../customers/marketplace/marketplace.model';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-admin-market',
  templateUrl: './admin-market.component.html',
  styleUrls: ['./admin-market.component.scss'],
})
export class AdminMarketComponent implements OnInit {
  @ViewChild('AddShop') addProductComponent: AddProductComponent;

  public selMenu = 'manage-category';
  @ViewChild('dropdown') dropdown: ElementRef;
  private modalRef: any;
  product_list: any;
  categories: any;
  subcategories: any;
  categoryName: any;
  subcategoryName: any;
  selectedIndex = 0;
  selectedCatId: any = 0;
  selectedsubCatId: any;
  form: FormGroup;
  prodForm: FormGroup;
  editprodForm: FormGroup;
  bannerForm: FormGroup;
  bottomImagesForm: FormGroup;
  bottomImagesFormEdit: FormGroup;
  submitted = false;
  logoPath: any;
  qrPath: any;
  imgResultAfterCompress: any;
  selectedImage1: File;
  selectedImage3: File;
  selectedImage4: File;
  selectedImage2: File;
  imagePath1: any;
  imagePath2: any;
  imagePath3: any;
  imagePath4: any;
  iconPath1: any;
  selectedIcon1: File;
  iconPath2: any;
  selectedIcon2: File;
  iconPath3: any;
  selectedIcon3: File;
  iconPath4: any;
  selectedIcon4: File;
  jsonStrings: string;
  food_listing_response: any;
  imgUrl = environment.ImageUrl;
  food_details: any;
  food_image_1: any;
  food_image_2: any;
  food_image_3: any;
  food_icon_1: any;
  food_icon_2: any;
  food_icon_3: any;
  edit_product_id: any;
  food_image_1_url: any;
  food_image_1_url_show: number;
  food_image_2_url: any;
  food_image_2_url_show: number;
  food_image_3_url: any;
  food_image_3_url_show: number;
  food_image_4_url: any;
  food_image_4_url_show: number;
  food_icon_1_url: any;
  food_icon_1_url_show: number;
  food_icon_2_url: any;
  food_icon_2_url_show: number;
  food_icon_3_url: any;
  food_icon_3_url_show: number;
  food_icon_4_url: any;
  food_icon_4_url_show: number;
  get_selected_products_listing: any;
  selectedSubCatIndex: any = 0;
  foodSpecsArrayData: any[];
  get_all_product_banner_response: any;
  get_all_product_banner_length: any = 0;
  banner_image_url: any;
  banner_image_url_show: number;
  bannerPath: any;
  selectedBanner: File;
  foodSpecsLength: any;
  checkArray = [];
  showHideMemberPriceStatus: any;
  // ingredientsEdit: FormArray
  searchText: string = '';
  filteredProducts: any;
  bottom_banner_image_url: any;
  bottom_banner_image_url_show: number;
  bannerPathBottom: any;
  selectedBannerBottom: File;
  get_bottom_banner_response: any;
  get_one_bottom_banner_response: any;
  edit_bottom_banner_id: any;
  bottom_banner_image: any;
  bottom_edit_img_hide_show: boolean = false;
  adminId: any = 0;
  food_image_4: any;
  food_icon_4: any;
  shopWebLink: string = '';
  logo_image_show: number;
  logo_image_url: any;
  selectedLogo: File;
  qr_image_show: number;
  qr_image_url: any;
  selectedQr: File;
  qr_text: string = '';
  shop_logo: any = '';
  shop_qr_image: any = '';
  qr_text_value: any = '';
  productReview: any = {
    userName: '',
    comment: '',
    rating: 0,
  };
  imgBase64: any = '';
  addReviewModal: any = null;
  percent_value = 0;
  percent_type = 0;
  // elementType = NgxQrcodeElementTypes.URL;
  // correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  QrCodeValue = '';
  shopName: string = '';
  shopNameArray: any = [];
  store_link: string = '';
  unit: string = '';

  data: any = [];
  value: any = 0;
  option: any = {
    currentPage: 1,
  };
  icons: any = [
    { dropdown: ['Popular', 'Top 10'], value: '', text: '', showText: false },
    { dropdown: ['Save Up Program'], value: '', text: '', showText: true },
    {
      dropdown: ['South', 'North East', 'West', 'North', 'East'],
      value: '',
      text: '',
      showText: true,
    },
  ];
  focusIcon: any = {};
  isTabDetailActive = 1;
  isTabDescriptionActive = 1;
  formType = 'Create';
  moreProductsSelect: any = [];
  moreProductsValue = 0;

  isLoading: boolean = false;

  specialCategories = [
    'Car',
    'Entertainment',
    'Phone',
    'Property',
    'Courier',
    'Popular Now',
    'Repair',
    '1 Day Delivery',
    '3 Hr Express',
    'Courier',
    'Fruits',
  ];

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private customerService: CustomerService,
    public commonService: CommonService,
    private route: ActivatedRoute
  ) {
    this.memberShopSubcategories = structuredClone(this.commonService.subRegionLists.map((i: any) => {
      return {
        id: i.id,
        name: i.name,
        region: i.regionName,
      };
    }));

    this.route.queryParams.subscribe(param => {
      if (param['menu']) {
        this.selMenu = param['menu']
      }
    })
  }

  ngOnInit(): void {
    this.initDropdown();
    this.category_listing();
    this.generateForm();
    this.generateFormValidator();
    this.getMemberShopProduct();
    this.getAllProfileCharacter();
    this._getMembersDetails();
    this.getModeInfo();
    this.getSubRegionList();
  }
  get product() {
    return this.prodForm.controls;
  }
  get editproduct() {
    return this.editprodForm.controls;
  }

  handleSearchMemberShop(event: any) {
    this.getMemberShopProduct(event.target.value);
  }

  generateForm() {
    this.prodForm = this.fb.group({
      name: ['', [Validators.required]],
      descp: ['', [Validators.required]],
      memPrice: ['', Validators.required],
      chat_url: [''],
      seller_info: [''],
      nonMemPrice: [''],
      costPrice: [''],
      qty: ['', [Validators.required]],
      // qtyName1: ["", [Validators.required]],
      // qtyPrice1: ["", [Validators.required]],
      // qtyName2: [""],
      // qtyPrice2: [""],
      // qtyName3: [""],
      // qtyPrice3: [""],
      // qtyName4: [""],
      // qtyPrice4: [""],
      image1: ['', [Validators.required]],
      image2: [''],
      image3: [''],
      image4: [''],
      icon1: [''],
      icon2: [''],
      icon3: [''],
      icon4: [''],
      ingredients: this.fb.array([this.newIngredient()]),
    });
  }
  newIngredient(): FormGroup {
    return this.fb.group({
      weight: ['', [Validators.required]],
      price: ['', [Validators.required]],
      nprice: [''],
      costPrice: [''],
    });
  }
  generateFormValidator() {
    let sellerInfo = '<b> Seller Info </b>\n';
    sellerInfo +=
      'Information is not provided. Please do contact Seller via other methods\n\n';
    sellerInfo += '<b> Delivery </b>\n';
    sellerInfo += 'Delivery options are not specified.\n\n';
    sellerInfo += '<b> Ambassador Program </b>\n';
    sellerInfo += 'Seller is not part of any AP program.\n\n';

    this.editprodForm = this.fb.group({
      name: ['', [Validators.required]],
      descp: ['', [Validators.required]],
      charges: ['', [Validators.required]],
      delivery: ['', [Validators.required]],
      chat_url: [''],
      seller_info: [sellerInfo],
      image1: [''],
      image2: [''],
      image3: [''],
      image4: [''],
      icon1: [''],
      icon2: [''],
      icon3: [''],
      icon4: [''],
      ingredientsEdit: this.fb.array([this.newIngredientEdit()]),
      more_products: [[]],
    });
  }

  onScroll() {
    const element = this.dropdown.nativeElement;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      if (!this.isLoading) {
        this.initDropdown();
      }
    }
  }

  initDropdown() {
    this.isLoading = true;
    let formData = new FormData();
    formData.append('page', this.option.currentPage);

    this.auth
      .admin_marketplace_food_listing_email(formData)
      .subscribe((response: any) => {
        this.option.currentPage += 1;
        // console.log(response.body);
        response.body.forEach((element) => {
          // console.log(element.user_detail, element.email);
          this.data.push({
            value: element.email,
            label: `${element.email} (${element.user_detail?.shop_name ?? '-'
              })`,
            // data: { color: 'purple', name: 'Lilac' }
          });
          this.shopNameArray[element.email] =
            element.user_detail?.shop_name ?? '';
        });
        this.isLoading = false;
      });
  }

  update() {
    this.product_listing('', this.value);
  }

  product_listing(searchText = '', email = '') {
    let formData = new FormData();
    if (email != '') {
      formData.append('email', email);
    }
    formData.append('searchText', searchText);

    this.auth.admin_marketplace_food_listing(formData).subscribe(
      (response: any) => {
        this.product_list = response.body;
        this.product_list.map((data) => {
          this.moreProductsSelect.push({
            value: data.id.toString(),
            label: data.name,
          });
          if (
            data.marketplace_product.categoryId == null &&
            data.marketplace_product.subcateoryId == null
          ) {
            data.subcategories = [];
          } else {
            data.subcategories = this.subcategories?.filter(
              (item) => item.parentId == data.marketplace_product.categoryId
            );
          }

          if (data?.special_category?.length) {
            data.special_category = JSON.parse(data.special_category);
          } else {
            data.special_category = [];
          }
        });
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
        if (e.error.status == 401 || e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  category_listing() {
    this.auth.marketplace_categories().subscribe(
      (response: any) => {
        this.categories = response.body;
        this.subcategory_listing();
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  subcategory_listing() {
    this.auth.marketplace_all_subcategories().subscribe(
      (response: any) => {
        this.subcategories = response.body;
        this.product_listing();
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  onChangeCategory(categoryId, productId) {
    const index = this.product_list.findIndex((item) => item.id == productId);
    this.product_list[index].marketplace_product.categoryId = categoryId;
    this.product_list[index].marketplace_product.foodId = productId;
    this.product_list[index].subcategories = this.subcategories.filter(
      (item) => item.parentId == categoryId
    );
    this.toastr.info('Please select subcategory to show this product.');

    if (categoryId == '') {
      this.onChangeSubcategory('', productId);
    }
  }

  onChangeSubcategory(subCategoryId, productId) {
    const index = this.product_list.findIndex((item) => item.id == productId);
    this.product_list[index].marketplace_product.subcategoryId = subCategoryId;

    const finalItem = this.product_list.find((item) => item.id == productId);
    if (finalItem) {
      let formData = new FormData();
      formData.append('foodId', finalItem.id);
      formData.append('categoryId', finalItem.marketplace_product.categoryId);
      formData.append(
        'subcategoryId',
        finalItem.marketplace_product.subcategoryId
      );

      this.auth.add_product_to_marketplace(formData).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
          if (e.error.status == 401 || e.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          }
        }
      );
    } else {
      return this.toastr.error('Product not found.');
    }
  }

  featuredProduct(productId) {
    let formData = new FormData();
    formData.append('foodId', productId);

    this.auth.set_marketplace_featured_product(formData).subscribe(
      (response: any) => {
        // this.toastr.success(response.message);
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
        if (e.error.status == 401 || e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  searchProductShop(text) {
    if (text.trim().length >= 0) {
      this.product_listing(text.trim());
    } else {
      this.product_listing();
    }
  }

  getUnselectedSpecialCategories(special_category) {
    if (special_category == null) return [];
    return this.specialCategories.filter(
      (item) => !special_category.includes(item)
    );
  }

  onChangeSpecialCategory(value, food, index, isAdd = true) {
    if (value == '#') {
      return;
    }

    let special_category = food.special_category;
    let body: any = {
      food_id: food.id,
      special_category: [],
    };

    body.special_category = [...special_category];

    if (isAdd) {
      body.special_category.push(value);
    } else {
      body.special_category = body.special_category.filter(
        (cat) => cat != value
      );
    }

    body.special_category = JSON.stringify(body.special_category);
    this.auth.updateSpecialCategory(body).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.product_list[index].special_category = JSON.parse(
          body.special_category
        );
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
        if (e.error.status == 401 || e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  editProductModal(event, modal, food_id): void {
    this.addProductComponent.customTitle = 'Edit Product'
    this.addProductComponent.enableMemberShop = false;
    this.addProductComponent.editProductModal(food_id);
    event.preventDefault();
    // this.modalService.dismissAll();
    // this.modalRef = this.modalService.open(modal, {
    //   size: 'xl',
    //   ariaLabelledBy: 'modal-basic-title',
    // });
    // // // console.log(modal);

    // this.edit_product_id = food_id;

    // let formData = new FormData();
    // formData.append('foodId', food_id);

    // this.auth.get_food_details(formData).subscribe(
    //   (response: any) => {
    //     this.food_details = response.body;
    //     // // console.log(this.food_details, '------------------ get food details')
    //     // this.getAllCategories();

    //     this.unit =
    //       this.food_details.unit == 'null' ? '' : this.food_details.unit;
    //     this.percent_value = this.food_details.percent_value;
    //     this.percent_type = this.food_details.percent_type;

    //     this.food_image_1 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'image1'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'image1'
    //           ).image;
    //     this.food_image_2 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'image2'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'image2'
    //           ).image;
    //     this.food_image_3 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'image3'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'image3'
    //           ).image;
    //     this.food_image_4 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'image4'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'image4'
    //           ).image;
    //     this.food_icon_1 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'icon1'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'icon1'
    //           ).image;
    //     this.food_icon_2 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'icon2'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'icon2'
    //           ).image;
    //     this.food_icon_3 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'icon3'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'icon3'
    //           ).image;
    //     this.food_icon_4 =
    //       this.food_details.foodImages.find(
    //         (o) => o.imageAccessor === 'icon4'
    //       ) == undefined
    //         ? ''
    //         : this.food_details.foodImages.find(
    //             (o) => o.imageAccessor === 'icon4'
    //           ).image;

    //     let foodSpecsArray = [];

    //     this.foodSpecsLength = response.body.foodSpecs.length;
    //     if (this.food_details.icons != null) {
    //       JSON.parse(this.food_details.icons).map((row: any, index: number) => {
    //         this.icons[index] = {
    //           ...this.icons[index],
    //           ...row,
    //         };
    //       });
    //     } else {
    //       this.icons.map((row: any) => {
    //         row.value = '';
    //       });
    //     }

    //     response.body.foodSpecs.forEach((element) => {
    //       foodSpecsArray.push({
    //         id: element.id,
    //         weight: element.value,
    //         nprice: element.nKey,
    //         price: element.key,
    //         costPrice: element.costPrice,
    //         outOfStockSingle: element.outOfStockSingle,
    //       });

    //       if (element.outOfStockSingle == 1) {
    //         this.checkArray.push(true);
    //       }
    //     });

    //     // this.foodSpecsArrayData = foodSpecsArray;

    //     this.patchBlocks(foodSpecsArray);
    //     // delete response.body.ingredientsEdit;
    //     const sellerInfo = this.food_details.seller_info;
    //     const chatUrl = this.food_details.chat_url;

    //     let sellerInfoDefault = '<b> Seller Info </b>\n';
    //     sellerInfoDefault +=
    //       'Information is not provided. Please do contact Seller via other methods\n\n';
    //     sellerInfoDefault += '<b> Delivery </b>\n';
    //     sellerInfoDefault += 'Delivery options are not specified.\n\n';
    //     sellerInfoDefault += '<b> Ambassador Program </b>\n';
    //     sellerInfoDefault += 'Seller is not part of any AP program.\n\n';
    //     this.editprodForm.patchValue({
    //       name: this.food_details.name,
    //       descp: this.food_details.description,
    //       charges: this.food_details.charges,
    //       delivery: this.food_details.delivery,
    //       chat_url:
    //         chatUrl != '' && chatUrl != 'null'
    //           ? this.food_details.chat_url
    //           : '',
    //       seller_info:
    //         sellerInfo != '' && sellerInfo != 'null' && sellerInfo != null
    //           ? this.food_details.seller_info
    //           : sellerInfoDefault,
    //       memPrice: this.food_details.memberPrice,
    //       nonMemPrice: this.food_details.mrp,
    //       costPrice: this.food_details.costPrice,
    //       qty: this.food_details.maxQty,
    //       outOfStockAll: this.food_details.outOfStockAll,
    //       more_products:
    //         this.food_details.more_products != null
    //           ? JSON.parse(this.food_details.more_products)
    //           : [],
    //     });
    //   },
    //   (e) => {
    //     this.toastr.error(e.error.message);
    //     this.modalService.dismissAll();
    //   }
    // );
  }

  patchBlocks(blocksData) {
    // // console.log(blocksData,'-------------------------------blobks data-----------------------------------')
    let items = this.editprodForm.get('ingredientsEdit') as FormArray;
    // // console.log(items,'------------------------------pathc block items')

    while (items.length > 0) {
      items.removeAt(0);
    }

    // // console.log(items,'------------------------------pathc block items 1')

    blocksData.forEach((element, index) => {
      if (index >= 0) {
        items.push(this.newIngredientEdit());
      }
    });

    // // console.log(items,'------------------------------pathc block items 2')
    // // console.log(blocksData.length,'---------------------------')
    // // console.log(items.value.length,'---------------------------')
    // return

    if (blocksData.length == items.value.length) {
      // // console.log('-------------------------------LENGTH EQUAL------------------------------')
      // // console.log("blocksData...", blocksData);
      this.editprodForm.patchValue({
        ingredientsEdit: blocksData,
      });
    }

    // // console.log(items,'------------------------------pathc block items 22')
  }
  newIngredientEdit(): FormGroup {
    return this.fb.group({
      weight: ['', [Validators.required]],
      price: ['', [Validators.required]],
      nprice: [''],
      costPrice: [''],
      outOfStockSingle: [''],
    });
  }

  updateFoodPercent(value, type) {
    if (value < 0) {
      this.toastr.warning('Less than zero not allowed');
    }

    if (type == 1) {
      const regex = /^[0-9]+(\.[0-9]+)?$/;
      const regexTest = regex.test(value);

      if (regexTest == false) {
        return this.toastr.warning('Enter valid number');
      }
    }

    if (value == true) value = 1;
    if (value == false) value = 0;

    let formData = new FormData();
    formData.append('food_id', this.edit_product_id);
    formData.append('value', value);
    formData.append('type', type);

    this.auth.updateFoodPercent(formData).subscribe(
      (response: any) => {
        if (type == 2) {
          this.toastr.success(response.message);
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  checkAllCheckboxes(event) {
    if (event.target.checked == true) {
      $('.check_box_all').each(function () {
        $(this).prop('checked', true);
      });

      let items = this.editprodForm.get('ingredientsEdit') as FormArray;

      // let items = this.editprodForm.get('ingredientsEdit');
      // // console.log(items.controls,'-----------------controls')

      // // console.log(this.editprodForm.get('ingredientsEdit').controls)

      items.controls.map((control) => {
        let newForm = control as FormGroup;
        // control.setValue(true);
        // // console.log(control,'-----------------------map control')
        newForm.controls.outOfStockSingle.setValue(true);
        // // console.log(newForm.controls.outOfStockSingle.setValue(true),'----------------------------map controls')
      });
    } else {
      $('.check_box_all').each(function () {
        $(this).prop('checked', false);
      });

      let items = this.editprodForm.get('ingredientsEdit') as FormArray;

      items.controls.map((control) => {
        let newForm = control as FormGroup;
        // control.setValue(true);
        // // console.log(control,'-----------------------map control')
        newForm.controls.outOfStockSingle.setValue(false);
        // // console.log(newForm.controls.outOfStockSingle.setValue(true),'----------------------------map controls')
      });
    }
  }
  editProd() {
    this.submitted = true;
    // // console.log(this.editprodForm,'---------------------------------------this.editprodForm')
    // return
    if (this.editprodForm.invalid) {
      // alert()
      // // console.log(this.editprodForm,'--------------invalid')
      return;
    }

    // // console.log('------------------HERE-------------------')
    // return
    this.editprodForm.value.image1 = this.selectedImage1;
    this.editprodForm.value.image2 = this.selectedImage2;
    this.editprodForm.value.image3 = this.selectedImage3;
    this.editprodForm.value.image4 = this.selectedImage4;
    this.editprodForm.value.icon1 = this.selectedIcon1;
    this.editprodForm.value.icon2 = this.selectedIcon2;
    this.editprodForm.value.icon3 = this.selectedIcon3;
    this.editprodForm.value.icon4 = this.selectedIcon4;
    this.editprodForm.value.categoryId = this.selectedCatId;
    this.editprodForm.value.subCategoryId = this.selectedsubCatId;
    let jsonString = this.editprodForm.value.ingredientsEdit;
    if (jsonString.length == 0) {
      this.toastr.error('Please add atleast one variation.');
      return;
    }

    this.spinner.show();

    const detail = this.product_list.filter(
      (row: any) => row.id == this.edit_product_id
    )[0];
    // console.log(detail);

    let jsonStrings = JSON.stringify(jsonString);
    const formData = new FormData();
    // formData.append('categoryId', this.editprodForm.value.categoryId);
    // formData.append('subCategoryId', this.editprodForm.value.subCategoryId);
    formData.append('categoryId', '');
    formData.append('subCategoryId', '');
    formData.append('name', this.editprodForm.value.name);
    formData.append(
      'mrp',
      this.editprodForm.value.nonMemPrice == ''
        ? 0
        : this.editprodForm.value.nonMemPrice
    );
    formData.append(
      'memberPrice',
      this.editprodForm.value.memPrice == ''
        ? 0
        : this.editprodForm.value.memPrice
    );
    formData.append(
      'costPrice',
      this.editprodForm.value.costPrice == ''
        ? 0
        : this.editprodForm.value.costPrice
    );
    formData.append('description', this.editprodForm.value.descp);
    formData.append('charges', this.editprodForm.value.charges);
    formData.append('delivery', this.editprodForm.value.delivery);
    formData.append('chat_url', this.editprodForm.value.chat_url);
    formData.append('seller_info', this.editprodForm.value.seller_info);
    formData.append(
      'maxQty',
      this.editprodForm.value.qty == '' ? 0 : this.editprodForm.value.qty
    );
    formData.append('jsonString', jsonStrings);
    formData.append('image1', this.editprodForm.value.image1);
    formData.append('image2', this.editprodForm.value.image2);
    formData.append('image3', this.editprodForm.value.image3);
    formData.append('image4', this.editprodForm.value.image4);
    formData.append('icon1', this.editprodForm.value.icon1);
    formData.append('icon2', this.editprodForm.value.icon2);
    formData.append('icon3', this.editprodForm.value.icon3);
    formData.append('icon4', this.editprodForm.value.icon4);
    formData.append('unit', this.unit);
    formData.append('foodId', this.edit_product_id);
    formData.append('outOfStockAll', this.editprodForm.value.outOfStockAll);
    formData.append(
      'more_products',
      JSON.stringify(this.editprodForm.value.more_products)
    );
    const icons = this.icons;
    formData.append(
      'icons',
      JSON.stringify(
        icons.map((row: any) => {
          return {
            value: row.value,
            text: row.text,
          };
        })
      )
    );

    this.auth.edit_food(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.modalService.dismissAll();
        this.editprodForm.reset();
        this.checkArray = [];
        this.spinner.hide();
        // this.getAllCategories();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );
    // // console.log(formData, 'formData----==============================');
  }
  show_add_review_modal(content) {
    this.addReviewModal = this.modalService.open(content, {
      size: 'sm',
      // backdrop: 'static',
    });
  }
  show_add_icon_modal(content, item: any, index: number) {
    this.addReviewModal = this.modalService.open(content, {
      size: 'sm',
      // backdrop: 'static',
    });
    this.focusIcon = item;
    this.focusIcon.index = index;
  }

  handleTypeIcon() {
    const icon = this.focusIcon;
    const value = `${this.food_details.percent_type == 0 ? '$' : ''}${this.food_details.percent_value
      }${this.food_details.percent_type == 0 ? '' : '%'}`;

    if (icon.index == 1) {
      this.focusIcon.text = `<br/><br/><b> Save Up Program </b><br/>\n`;
      this.focusIcon.text += `Upload receipt upon completion to get an additional <b><u>${value}</u></b> OFF your bill. <br />\nContinue supporting your favourite business to SaveUp even More in future!`;
    } else if (icon.index == 2) {
      this.focusIcon.text = `<br/><br/><b>Location</b><br/>\n`;
      this.focusIcon.text += `Business operates only in the <b><u>${icon.value}</u></b> locale.`;
    }
  }

  saveIcon(isCancel = false) {
    const icon = this.focusIcon;
    if (isCancel) {
      this.focusIcon.value = '';
      this.icons[icon.index] = this.focusIcon;
      document.getElementById('closeIconModal').click();
      return;
    }

    if (icon.value == '') {
      return this.toastr.error('Please Select the Type !');
    }

    this.icons[icon.index] = this.focusIcon;
    document.getElementById('closeIconModal').click();
  }

  onImageSelected1(files, modal, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_1_url = event.target.result;
        this.food_image_1_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.imagePath1 = files;
    this.selectedImage1 = <File>files[0];
  }

  onImageSelected2(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_2_url = event.target.result;
        this.food_image_2_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.imagePath2 = files;
    this.selectedImage2 = <File>files[0];
  }

  onImageSelected3(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_3_url = event.target.result;
        this.food_image_3_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.imagePath3 = files;
    this.selectedImage3 = <File>files[0];
  }

  onImageSelected4(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_4_url = event.target.result;
        this.food_image_4_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.imagePath4 = files;
    this.selectedImage4 = <File>files[0];
  }

  onIconSelected1(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_icon_1_url = event.target.result;
        this.food_icon_1_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.iconPath1 = files;
    this.selectedIcon1 = <File>files[0];
  }

  onIconSelected2(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_icon_2_url = event.target.result;
        this.food_icon_2_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.iconPath2 = files;
    this.selectedIcon2 = <File>files[0];
  }

  onIconSelected3(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_icon_3_url = event.target.result;
        this.food_icon_3_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.iconPath3 = files;
    this.selectedIcon3 = <File>files[0];
  }

  onIconSelected4(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_icon_4_url = event.target.result;
        this.food_icon_4_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.iconPath4 = files;
    this.selectedIcon4 = <File>files[0];
  }
  saveSeletedImage(event) {
    let file = event.target.files[0];
    this.productReview.image = file;
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imgBase64 = fileReader.result;
    };
    fileReader.readAsDataURL(file);
  }
  saveProductReview() {
    let formData = new FormData();
    for (let key in this.productReview) {
      if (this.productReview.hasOwnProperty(key)) {
        formData.append(key, this.productReview[key]);
      }
    }
    formData.append('foodId', this.edit_product_id);
    this.auth.add_product_review(formData).subscribe(
      (response: any) => {
        this.productReview = {
          userName: '',
          comment: '',
          rating: 0,
        };
        this.imgBase64 = '';
        this.toastr.success(response.message);
        try {
          // Close the review modal
          this.addReviewModal.close();
        } catch (error) {
          // console.log('error closing modal', error);
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  checkRating(event) {
    // console.log('event ====>', event);
    if (event?.target?.valueAsNumber > 5) {
      this.productReview.rating = 5;
    }

    if (event?.target?.valueAsNumber < 0) {
      this.productReview.rating = 0;
    }
  }
  openSelectImageDialog(selector) {
    document.querySelector(selector).click();
  }

  /* ----------------------------------------------------------------------------------------------------- */
  /*  member shop
 /* ----------------------------------------------------------------------------------------------------- */

  public memberShopCategories: Array<any> = [];
  public memberShopSubcategories: Array<any> = [];

  public selectMenu(menu: string) {
    this.router.navigate(['/admin/manage-market'], {
      queryParams: {
        menu: menu
      }
    })
    // this.selMenu = menu;
  }

  public memberShopProductList: Array<any> = [];
  public getMemberShopProduct(search = null): void {
    this._getMemberShopCategories();
    console.log("FETCH getMemberShopProductList 2")
    this.customerService
      .getMemberShopProductList({
        categoryId: null,
        subCategoryId: null,
        search: search,
        isAdmin: true,
        limit: 1001
      })
      .subscribe((response: ApiResponse) => {
        this.memberShopProductList = response.body.data;
        this.memberShopProductList.map((row: any) => {
          row.hiddenBy = row.hiddenBy != null ? JSON.parse(row.hiddenBy) : [];
          row.isHidden = row.hiddenBy?.length > 1;
        });
      });
  }

  handleHideProduct(item: any) {
    this.local
      .alertConfirm({
        message: `Are you sure want to hide this product ?`,
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});
          this.auth
            .hideMemberShopProduct({
              productId: item.id,
              isAdmin: true,
              unhide: item.isHidden,
            })
            .subscribe(
              (resp: any) => {
                Swal.close();
                this.toastr.success(resp.message);
                this.getMemberShopProduct();
              },
              (e) => {
                Swal.close();
                this.toastr.error(e.error.message);
              }
            );
        }
      });
  }

  private _getMemberShopCategories() {
    this.auth
      .getAllMemberCategorieRelationship()
      .subscribe((resp: ApiResponse) => {
        this.memberShopCategories = resp.body;
      });
  }

  public shopUpdate(event: any) {
    if (event == 'save_shop_profile') {
      this.getMemberShopProduct();
    } else if (event == 'productUpdate') {
      this.getMemberShopProduct();
    }
  }

  public editShopProfile(shopId: any) {
    this.addProductComponent.openShopInfoModalById(shopId);
  }

  public editMemberShopProduct(product: any) {
    this.addProductComponent.memberShopProductType = product?.type;
    this.addProductComponent.selectedCatId = product?.categoryId;
    this.addProductComponent.selectedCategoryNameForDD = product?.categoryName;
    this.addProductComponent.selectedSubRegionId = product?.subRegionId;
    this.addProductComponent.editProductModal(product?.id);
  }

  public deleteMemberShopProduct(productId: any) {
    this.addProductComponent.delete_food(productId);
  }

  public onChangeMemberShopCategoryChange(id: any, product: any) {
    let payload = { categoryId: id, productId: product.id };
    this.auth.updateProductCategory(payload).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
    });
  }

  public onChangeMemberShopSubCategoryChange(updatedValue: any, product: any) {
    let payload = {
      jsonString: JSON.stringify([
        {
          id: product.subCategoryId,
          name: updatedValue,
          categoryId: product.categoryId,
        },
      ]),
    };
    this.auth
      .updateMemberProductSubCategory(payload)
      .subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
      });
  }
  public editMode: boolean = false;
  public selectedData: any = null;

  public openProductCharForAddEdit(model, selected: any = null) {
    if (selected) {
      this.editMode = true;
      this.selectedData = selected;
      this.profileCharacterName = selected?.name;
      this.profileCharacterDescription = selected?.description;
      this.profileCharacterCategory = selected?.category.toLowerCase();
      this.profileCharacterPrice = selected?.price || 0;
    }

    this.addReviewModal = this.modalService.open(model, {
      size: 'xs',
      // backdrop: 'static',
      windowClass: 'suggestion',
    });
  }

  public openAttachImagePopupSugg(selector) {
    document.querySelector(selector).click();
  }

  public suggestionBase64: any = null;
  public suggestionAttachment: any = null;

  public saveProductCharSelectedImage(event) {
    this.selectedData ? (this.selectedData.image = null) : '';
    let file = event.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.suggestionBase64 = fileReader.result;
      this.suggestionAttachment = file;
    };
    fileReader.readAsDataURL(file);
  }

  // Profile Character
  public profileCharacterName: string = '';
  public profileCharacterDescription: string = '';
  public profileCharacterCategory: string = '';
  public profileCharacterType = PROFILE_CHARACTER_TYPE;
  public profileCharacterPrice = 0;

  public saveProfileCharacter() {
    let formData = new FormData();
    let profileCharacterDescription = this.profileCharacterDescription.trim();
    let profileCharacterName = this.profileCharacterName.trim();
    formData.append('name', profileCharacterName);
    formData.append('description', profileCharacterDescription);
    this.selectedData?.image
      ? ''
      : formData.append('image', this.suggestionAttachment);
    formData.append('category', this.profileCharacterCategory);
    formData.append('price', this.profileCharacterPrice.toString());
    if (this.editMode) {
      formData.append('id', this.selectedData?.id);
    }
    if (
      profileCharacterName &&
      profileCharacterDescription &&
      (this.selectedData?.image || this.suggestionAttachment)
    ) {
      this.auth.addProfileCharacter(formData).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.getAllProfileCharacter();
          this.addReviewModal.close();
          this.profileCharacterName = '';
          this.profileCharacterDescription = '';
          this.profileCharacterCategory = '';
          this.selectedData =
            this.suggestionAttachment =
            this.suggestionBase64 =
            null;
          this.editMode = false;
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
    } else {
      this.toastr.error('Add All Details!');
    }
  }

  public allProfileCharacter: Array<any> = [];
  public getAllProfileCharacter(): void {
    this.auth.getAllProfileCharacter().subscribe((response: ApiResponse) => {
      this.allProfileCharacter = response.body;
    });
  }

  public deleteProductCharacter(id): void {
    this.auth.deleteProfileCharacter(id).subscribe(
      (response: ApiResponse) => {
        this.toastr.success(response.message);
        this.getAllProfileCharacter();
      },
      (error: any) => {
        this.toastr.error('Remove Assign Member First!');
      }
    );
  }

  //Members

  public members: Array<any> = [];
  public totalMembers: Member[] = [];
  public currentValue: number = 0;
  public highValue: number = 100;
  public page = 1;
  public pageSize = 10;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>Level:</b>' + value;
        case LabelType.High:
          return '<b>Level:</b>' + value;
        default:
          return '' + value;
      }
    },
  };

  /**
   * get member details based on created date - dateCreated
   */
  private _getMembersDetails(): void {
    this.auth.getMembersDetails().subscribe((response: ApiResponse) => {
      this.totalMembers = response?.body || [];
      this.nextPage();
    });
  }

  public onLevelChange() {
    this.members = this.totalMembers.filter(
      (i: any) =>
        i.level >= this.currentValue && this.currentValue <= this.highValue
    );
  }

  public selectMember(member, isChecker: boolean) {
    this.members = this.members.map((i: any) => {
      if (member.id == i.id) {
        if (i?.check == true) {
          i.check = isChecker;
        } else {
          i['check'] = isChecker;
        }
      }
      return i;
    });
  }

  public onSort({ column, direction }: SortEvent): void {
    // resetting other headers - do later
    for (const header of this.headers) {
      if (header.sortable !== column) {
        header.direction = '';
      }
    }

    // sorting countries
    if (direction === '' || column === '') {
      this.nextPage();
    } else {
      this.members = [...this.totalMembers].sort((a, b) => {
        const res = this._compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  private _compare(v1: string | number, v2: string | number) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  public nextPage(): void {
    this.members = this.totalMembers.slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  public openAssignProfile(model: any, selected: any = null) {
    this._getAllAssignCharList();
    if (selected) {
      this.selectedData = selected;
    }
    this.addReviewModal = this.modalService.open(model, {
      size: 'lg',
      // backdrop: 'static',
    });
  }

  public assignProfileCharacterToMember() {
    let selectedMember = this.members.filter((i) => i.check).map((i) => i.id);
    this.auth
      .addProfileCharacterToMember({
        userIdList: selectedMember,
        characterId: this.selectedData.id,
      })
      .subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.editMode = false;
          this.selectedData = null;
          this.addReviewModal.close();
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  private _getAllAssignCharList() {
    this.auth
      .getAllProfileCharacterForMember()
      .subscribe((response: ApiResponse) => {
        let memberWithCharacterAssign = response.body;
        this.members.map((i) => {
          let currentMemberCharacter = memberWithCharacterAssign.find(
            (c) => c.userId == i.id && c.characterId == this.selectedData.id
          );
          if (currentMemberCharacter) {
            i['enableRemoveBtn'] = currentMemberCharacter.id;
          } else if (i['enableRemoveBtn']) {
            i['enableRemoveBtn'] = null;
          }
        });
      });
  }

  public removeCharacterFromMember(selectedMemberCharacter: any): void {
    this.auth
      .deleteProfileCharacterFromMember(selectedMemberCharacter)
      .subscribe((response: ApiResponse) => {
        this.toastr.success(response.message);
        this._getAllAssignCharList();
      });
  }

  public modeEnable: any = 0;
  public getModeInfo() {
    this.auth.signInTestMode({}).subscribe((response: any) => {
      this.modeEnable = response.message?.enable ? '1' : '0';
    });
  }

  public saveMode() {
    this.auth
      .signInTestMode({ enable: this.modeEnable == '1' })
      .subscribe((response: any) => {
        this.toastr.success('Save Successfully');
      });
  }

  public subRegionList: Array<any> = [];
  private getSubRegionList(): void {
    this.auth.getMemberShopSubRegion().subscribe((response: ApiResponse) => {
      this.subRegionList = response?.body || [];
    });
  }

  public updateMemberShopProductSubRegionId(updatedValue: any, product: any) {
    this.auth
      .updateMemberShopProductSubRegionId({
        subRegionId: updatedValue,
        productId: product,
      })
      .subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
      });
  }
}
